import * as ChannelTypes from 'remote/channels/types'

export function getChannelLabel(channel) {
  if (!channel) {
    return ''
  }
  switch (channel.type) {
    case ChannelTypes.PUBLIC:
    case ChannelTypes.PRIVATE:
      return channel.name
    case ChannelTypes.PERSONAL:
      return `My private docs`
    default:
      throw new Error(`Unknown channel type: ${channel.type}`)
  }
}
